import { Star, ExternalLink } from "lucide-react";
import { SITE, REVIEWS } from "../data/site";

const Stars = () => (
  <div className="flex gap-1" aria-label="Valutazione 5 stelle">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={18} className="fill-gold text-gold" aria-hidden="true" />
    ))}
  </div>
);

const ReviewsSection = ({ standalone = false }) => (
  <section
    data-testid="reviews-section"
    className={standalone ? "bg-white py-16 sm:py-20" : "bg-gold-soft py-16 sm:py-24"}
  >
    <div className="container-site">
      <div className="mx-auto max-w-3xl text-center">
        <p className="kicker">Recensioni</p>
        <h2 className="mt-3 font-serif text-3xl sm:text-4xl font-semibold text-navy">
          La fiducia dei miei clienti
        </h2>
        <div className="mt-5 flex justify-center">
          <Stars />
        </div>
        <p className="mt-5 text-base leading-relaxed text-slate-600">
          Le recensioni dei clienti assistiti dallo studio sono pubblicate e liberamente
          verificabili sul Profilo dell'attività Google. La loro autenticità è garantita
          dalla piattaforma che le ospita.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <a
            href={SITE.googleProfile}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-google-cta"
            className="btn-gold"
          >
            Leggi le recensioni su Google <ExternalLink size={15} aria-hidden="true" />
          </a>
          <a
            href={SITE.googleProfile}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-leave-cta"
            className="btn-outline-navy"
          >
            Lascia una recensione
          </a>
        </div>
      </div>

      {REVIEWS.length > 0 && (
        <div data-testid="reviews-grid" className="mt-12 grid gap-6 md:grid-cols-3">
          {REVIEWS.map((r) => (
            <figure key={r.author} className="card-elegant">
              <Stars />
              <blockquote className="mt-4 text-sm leading-relaxed text-slate-700">
                {r.text}
              </blockquote>
              <figcaption className="mt-4 text-sm font-semibold text-navy">
                {r.author}
              </figcaption>
            </figure>
          ))}
        </div>
      )}
    </div>
  </section>
);

export default ReviewsSection;
